<template>
    <!-- 全店产品排名查询 -->
    <div
        v-loading.fullscreen.lock="loading"
        class="shop-ranking-query"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, .5)"
        element-loading-custom-class="loading-style"
        element-loading-spinner="el-icon-loading"
    >
        <notice showIcon
            >现排名查询每天只能查100个关键词，今日已查<em> {{ usedNum }} </em>/100。</notice
        >
        <query-settings
            ref="querySettings"
            :rest-num="totalNum - usedNum"
            :query-type="0"
            @search="search"
            @getPageRange="getPageRange"
        >
            <div class="shop-info dfc">
                <div class="title">店铺信息：</div>
                <p class="shop-name textOver">
                    <a :href="getShopInfo.ShopUrl" target="_blank">{{ getShopInfo.CompanyName }}</a>
                </p>
                <el-button type="primary" size="medium" style="margin-left: 10px" @click="chooseShop"
                    >选择其他店铺</el-button
                >
            </div>
        </query-settings>

        <div v-show="pluginInstall">
            <rankListV2
                v-show="isShowList"
                ref="rankListV2"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="true"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
            />
        </div>

        <div v-show="!pluginInstall">
            <rankList
                v-show="isShowList"
                ref="rankList"
                :link-to-analysis="linkToAnalysis"
                :table-data="tableData"
                :query="query"
                :show-pagination="showPagination"
                @pageChange="pageChange"
                :productAnalysisPath="productAnalysisPath"
                :isUseNew="isUseNew"
            />
        </div>
        <otherShop ref="otherShop" @getShop="getShop" />
    </div>
</template>

<script>
import querySettings from '../components/querySettings';
import otherShop from '../components/otherShop';
import rankList from '../components/rankList';
import rankListV2 from '../components/rankListV2.vue';
import { cloneDeep } from 'lodash';
import { dataAnalysis } from '../common/dataAnalysis';
import notice from './../../../components/notice/index.vue';
import pluginsAnalysis from '../common/pluginsAnalysis';
export default {
    name: 'ShopRankingQuery',
    components: { querySettings, otherShop, rankList, notice, rankListV2 },
    mixins: [dataAnalysis, pluginsAnalysis],
    props: {
        linkToAnalysis: {
            type: Boolean,
            default: true,
        },

        checkVersion: Function,
        productAnalysisPath: {
            type: String,
            default: '/productAnalysis',
        },
        isUseNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            shopInfo: null,
            showPagination: false,
            shopName: '',
            queryPage: 0,
        };
    },
    computed: {
        getShopInfo({ shopInfo }) {
            let getShopInfo = shopInfo;
            if (!shopInfo) {
                // 刚开始没有值就取 menberinfo 里面的
                getShopInfo = cloneDeep(this.$store.state.info.memberInfo);
                getShopInfo.ShopUrl = getShopInfo.ShopAddress; // key值统一
                getShopInfo.WangWang = getShopInfo.Account; // 旺旺号
            }
            this.updateShopUrl(getShopInfo.ShopUrl);
            this.updateShopName(getShopInfo.CompanyName);
            // this.shopUrl = getShopInfo.ShopUrl;
            // this.shopName = getShopInfo.CompanyName; // 移动端获取不到店铺店址，只能拿店铺名匹配
            return getShopInfo;
        },
    },
    created() {
        judgeDazeCollector({
            name: '排名查询',
            operate: '进入',
            tag: '',
            value: '',
        });
    },
    methods: {
        getShop(val) {
            this.shopInfo = val;
        },

        search(keywords, portPagesValue) {
            this.queryPage = portPagesValue;
            if (this.checkVersion()) {
                return;
            }
            if (!this.getShopInfo.CompanyName) {
                this.$message.warning('请先选择店铺！');
                return;
            }

            this.showPagination = false;
            if (this.pluginInstall) {
                // 插件查询
                this.saveRankedQuery({ keywords });
            } else {
                this.beginStart(keywords);
            }
        },

        updateShopUrl(ShopUrl) {
            this.shopUrl = ShopUrl;
        },

        updateShopName(CompanyName) {
            this.shopName = CompanyName;
        },

        chooseShop() {
            if (this.checkVersion()) {
                return;
            }
            this.$refs.otherShop.show();
        },
    },
};
</script>

<style lang="scss" scoped>
.shop-ranking-query {
    .shop-info {
        .title {
            width: 100px;
            text-align: right;
        }
        .shop-name {
            width: 350px;
        }
    }
}
</style>
<style lang="scss">
.ranking-query-tips {
    i {
        color: #ff7300;
        margin-right: 5px;
    }
    em {
        color: red;
    }
}
.loading-style {
    .el-loading-spinner {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #fff;
        width: auto;
        left: 50%;
        transform: translateX(-50%);
        line-height: 22px;
        padding: 16px 24px;
        border-radius: 4px;
        p {
            margin-left: 8px;
            width: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 90vw;
            color: #666;
        }
    }
}
</style>
